<template>
  <div class="search">
    <div class="classForClickOutside" @click="setIsDetailVisible(false)"></div>

    <button class="search-revoke" v-show="isSearchComplete" @click="cancelSearch">
      <span class="fal fa-undo search-revoke__icon"></span>
      검색 취소
    </button>

    <div class="search-bar" @keyup.down="hoverDown" @keyup.up="hoverUp">
      <label for="scheduleSearch" class="blind">검색창</label>
      <input
        id="scheduleSearch"
        type="text"
        autocomplete="off"
        maxlength="30"
        placeholder="일정 검색"
        v-on:input="typing"
        @focus="setIsSearchDropDownVisible(true)"
        v-model="searchString"
        v-on:keyup.enter="search('')"
      />

      <button class="search-button" type="button" @click="search('')" aria-label="검색">
        <i class="fal fa-search" aria-hidden="true"></i>
        <span class="blind">검색</span>
      </button>
    </div>

    <div class="search-dropdown" v-show="isSearchDropDownVisible" @mouseleave="setActiveIndex(-1)">
      <ul class="search-dropdown__menu">
        <li
          v-show="searchString"
          v-for="(searchBoxInfo, index) in searchBoxInfoList"
          :key="index"
          :class="activeIndex === index ? 'active' : null"
          @mouseover="setActiveIndex(index)"
        >
          <a class="search-dropdown__menu--row" @click="searchBoxInfo.clickFunc"
            >{{ searchBoxInfo.searchName }}: <span class="bold">{{ searchString }}</span></a
          >
        </li>
        <li>
          <a class="search-dropdown__menu--row point-color" @click="openDetailSearch">상세 검색</a>
        </li>
      </ul>
    </div>

    <div class="modal modal-overlay" v-show="isDetailVisible">
      <div class="modal-window" style="width: 500px;">
        <div class="hw-modal-wrap modal-content">
          <div class="hw-modal-header">상세 검색</div>
          <div class="office_home_body">
            <div class="gt-d-table gt-mt-10">
              <div class="gt-w-20 gt-d-table-cell gt-align-middle">범위</div>
              <div class="gt-w-80 gt-d-table-cell gt-align-middle">
                <select type="text" class="hw-input gt-w-40" v-model="pno">
                  <option value="0">전체</option>
                  <option
                    v-for="projectInfo in projectList.mylist"
                    :value="projectInfo.basic_info_no"
                    v-bind:key="projectInfo.basic_info_no"
                    >{{ projectInfo.project_name }}</option
                  >
                  <option
                    v-for="projectInfo in projectList.shared_list"
                    :value="projectInfo.basic_info_no"
                    v-bind:key="projectInfo.basic_info_no"
                    >{{ projectInfo.project_name }}</option
                  >
                </select>
              </div>
            </div>
            <div class="gt-d-table gt-mt-10">
              <div class="gt-w-20 gt-d-table-cell gt-align-middle">기간</div>
              <div class="gt-w-80 gt-d-table-cell gt-align-middle">
                <input type="text" class="hw-input gt-w-40 cal_date" ref="searchStartDate" />
                <span>~</span>
                <input type="text" class="hw-input gt-w-40 cal_date" ref="searchEndDate" />
              </div>
            </div>
            <div class="gt-d-table gt-mt-10">
              <div class="gt-w-20 gt-d-table-cell gt-align-middle">제목</div>
              <div class="gt-w-80 gt-d-table-cell gt-align-middle">
                <input type="text" class="hw-input" v-model="searchSubject" />
              </div>
            </div>
            <div class="gt-d-table gt-mt-10">
              <div class="gt-w-20 gt-d-table-cell gt-align-middle">내용</div>
              <div class="gt-w-80 gt-d-table-cell gt-align-middle">
                <input type="text" class="hw-input" v-model="searchContent" />
              </div>
            </div>
          </div>

          <div class="hw-modal-footer">
            <button type="button" class="hw-button" @click="searchDetail">검색</button>
            <button type="button" class="hw-button secondary" @click="cancelSearch">취소</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'ScheduleSearchBox',
  data() {
    return {
      pno: 0,
      searchSubject: null,
      searchContent: null,
      searchStartDate: null,
      searchEndDate: null,
      isDetailVisible: false,
      searchString: '',
      isSearchComplete: false,
      projectList: {
        mylist: [],
        shared_list: [],
      },
      activeIndex: -1,
      searchBoxInfoList: [
        {
          searchName: '전체',
          clickFunc: () => this.search(0),
        },
        {
          searchName: '제목',
          clickFunc: () => this.search(1),
        },
        {
          searchName: '내용',
          clickFunc: () => this.search(2),
        },
      ],
    };
  },
  props: {
    isSearchDropDownVisible: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    hoverUp() {
      if (this.activeIndex <= 0) {
        return false;
      }
      this.activeIndex--;
    },
    hoverDown() {
      if (this.activeIndex >= this.searchBoxInfoList.length - 1) {
        return false;
      }
      this.activeIndex++;
    },
    setActiveIndex(index) {
      this.activeIndex = index;
    },
    setIsDetailVisible(isVisible) {
      this.isDetailVisible = isVisible;
    },
    typing(event) {
      this.searchString = event.target.value;
      if (event.target.value.length <= 0) {
        return false;
      }
      event.preventDefault();
      this.setIsSearchDropDownVisible(true);
      return false;
    },
    setIsSearchDropDownVisible(isVisible) {
      this.$emit('set-is-search-drop-down-visible', isVisible);
    },
    search(searchType) {
      this.searchStartDate = this.$refs['searchStartDate'].value;
      this.searchEndDate = this.$refs['searchEndDate'].value;

      window.ScheduleSearch.Search(searchType);

      this.isSearchComplete = true;
      this.setIsSearchDropDownVisible(false);
      this.setIsDetailVisible(false);
    },
    searchDetail() {
      this.searchStartDate = this.$refs['searchStartDate'].value;
      this.searchEndDate = this.$refs['searchEndDate'].value;

      let searchParam = {
        pno: this.pno,
        startDate: this.searchStartDate,
        endDate: this.searchEndDate,
        subject: this.searchSubject,
        content: this.searchContent,
      };

      window.ScheduleSearch.Search_detail(null, null, searchParam);

      this.isSearchComplete = true;
      this.setIsSearchDropDownVisible(false);
      this.setIsDetailVisible(false);
    },
    openDetailSearch() {
      this.projectList =
        window.HiworksSchedule && window.HiworksSchedule.project_list ? window.HiworksSchedule.project_list : [];
      this.setIsDetailVisible(true);
      this.setIsSearchDropDownVisible(false);
      window.$j('.cal_date').datepicker();
    },
    cancelSearch() {
      window.ScheduleSearch.Search_undo();
      this.isSearchComplete = false;
      this.setIsDetailVisible(false);
      this.setIsSearchDropDownVisible(false);

      this.pno = 0;
      this.searchSubject = null;
      this.searchContent = null;
      this.searchStartDate = null;
      this.searchEndDate = null;
      this.isDetailVisible = false;
      this.searchString = '';
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/base/variables';
.hw-button {
  display: inline-block;
  background-color: $primary-color;
  border: 1px solid $primary-color-hover;
  border-radius: 4px;
  color: #fff;
  padding: 5px 20px 6px;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  transition-duration: 0.1s;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;

  //hover
  &:hover,
  &:focus {
    color: #fff;
    background: darken($primary-color-hover, 10%);
    border-color: darken($primary-color-hover, 10%);
    outline: none;
  }

  //disabled
  &[disabled],
  &:disabled {
    cursor: default;
    opacity: 0.5;
    &:hover {
      background: $primary-color;
      border-color: $primary-color-hover;
    }
  }

  &.secondary {
    background-color: $secondary-color;
    border-color: $secondary-color-hover;
    color: #333;
    &:hover,
    &:focus {
      background-color: $secondary-color-hover;
      border-color: $secondary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $secondary-color;
        border-color: $secondary-color-hover;
      }
    }
  }

  &.info {
    background-color: $info-color;
    border-color: $info-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $info-color-hover;
      border-color: $info-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $info-color;
        border-color: $info-color-hover;
      }
    }
  }

  &.warning {
    background-color: $warning-color;
    border-color: $warning-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $warning-color-hover;
      border-color: $warning-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $warning-color;
        border-color: $warning-color-hover;
      }
    }
  }

  &.danger {
    background-color: $danger-color;
    border-color: $danger-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $danger-color-hover;
      border-color: $danger-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $danger-color;
        border-color: $danger-color-hover;
      }
    }
  }

  &.text {
    color: $primary-color;
    padding: 0 10px;
    background: transparent;
    border-color: transparent;
    //hover
    &:hover,
    &:focus {
      color: $primary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        color: $primary-color;
        background: transparent;
        border-color: transparent;
        opacity: 0.5;
      }
    }
  }

  &.outline-blue {
    background-color: #fff;
    border: 1px solid #c8c8c8;
    color: #2c86dc;
    &:hover {
      border-color: #2c86dc;
    }
  }

  &.outline-gray {
    background: #f1f1f1;
    border: 1px solid #c8c8c8;
    color: #444;
    &:hover {
      border-color: #8c8c8c;
    }
  }

  &.outline-gray2 {
    background: #fff;
    border: 1px solid #d6d6d6;
    color: #333;
    padding-left: 12px;
    padding-right: 12px;
    > i {
      color: #909090;
      float: right;
      margin-top: 4px;
      margin-left: 10px;
    }
    &:hover {
      background: #f6f6f6;
    }
    &:focus {
      > i {
        color: #575757;
      }
    }
    &[disabled],
    &:disabled {
      border-color: #f2f2f2;
      background: #ffffff;
      &,
      > i {
        color: #d0d0d0;
      }
    }
  }

  &.rounded {
    border-radius: 4px;
  }

  //이웃하는 버튼 간격
  & + .hw-button {
    margin-left: 14px;
  }
}
.modal {
  &.modal-overlay {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &-window {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  &-content {
    padding: 10px 20px;
  }

  &-footer {
    background: #ccc;
    padding: 10px;
    text-align: right;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s;

  .modal-window {
    transition: opacity 0.2s, transform 0.2s;
  }
}

.modal-leave-active {
  transition: opacity 0.2s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.hw-modal-header {
  padding-bottom: 20px;
  border-bottom: 1px solid #d6d6d6;
  font-size: 16px;
}

.hw-modal-body {
  padding-top: 20px;
  font-size: 14px;
  max-height: 580px;
  overflow-y: auto;
}

.hw-modal-footer {
  padding-top: 30px;
  text-align: center;
}
.search-row {
  cursor: pointer;
}
.office_home_body {
  color: #676767;
}
</style>

<style>
#ui-datepicker-div {
  z-index: 1011 !important;
}
</style>
